import { render, staticRenderFns } from "./PlantView.vue?vue&type=template&id=9b4e1610"
import script from "./PlantView.vue?vue&type=script&lang=js"
export * from "./PlantView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports